import { emojiMap, emojiUrl } from './emojiMap'
/** 传入messageBody（群系统消息SystemMessage，群提示消息GroupTip除外）
 * payload = {
 *  msgType: 'TIMTextElem',
 *  msgContent: {
 *    text: 'AAA[龇牙]AAA[龇牙]AAA[龇牙AAA]'
 *  }
 *}
 **/
export function decodeText(payload) {
    //匹配img标签
    const imgHtmlReg = /<img.*?(?:>|\/>)/gi
    //匹配img的src属性 
    const imgSrcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
    //匹配图片格式
    const imgFileReg = /\.(png|jpg|gif|jpeg|webp)/

    let renderDom = []
    // 文本消息
    let temp = payload
    let left = -1
    let right = -1
    // ↓↓↓适配客服工作台的<img>标签
    temp = temp.replace(imgHtmlReg, (img) => {
        const srcArr = img.match(imgSrcReg)
        return srcArr?  `[${srcArr[1]}]` : ''
    })
    // ↑↑↑适配客服工作台的<img>标签
    while (temp !== '') {
        left = temp.indexOf('[')
        right = temp.indexOf(']')
        temp = temp.replace(/<br\s*\/?>/gi, '\n').replace(/&nbsp;/g, ' ')
        switch (left) {
            case 0:
                if (right === -1) {
                    renderDom.push({
                        name: 'text',
                        text: temp
                    })
                    temp = ''
                } else {
                    let _emoji = temp.slice(0, right + 1)
                    // ↓↓↓适配客服工作台的<img>标签
                    if (imgFileReg.test(_emoji)) {
                        renderDom.push({
                            name: 'img',
                            src: _emoji.slice(1, right)
                        })
                        temp = temp.substring(right + 1)
                    }
                    // ↑↑↑适配客服工作台的<img>标签
                    else if (emojiMap[_emoji]) {
                        renderDom.push({
                            name: 'img',
                            src: emojiUrl + emojiMap[_emoji]
                        })
                        temp = temp.substring(right + 1)
                    } else {
                        renderDom.push({
                            name: 'text',
                            text: '['
                        })
                        temp = temp.slice(1)
                    }
                }
                break
            case -1:
                renderDom.push({
                    name: 'text',
                    text: temp
                })
                temp = ''
                break
            default:
                renderDom.push({
                    name: 'text',
                    text: temp.slice(0, left)
                })
                temp = temp.substring(left)
                break
        }
    }
    return renderDom
}
